import React from "react";
import {
  CodeOutlined,
  PageFoldPortraitOutlined,
  VideoOutlined,
  WorkbookOutlined,
} from "@toddle-edu/ds-icons";

export const MODALITY_TYPE_INFO_MAPPING = {
  TODDLE_DOC: {
    label: "common:document",
    icon: <PageFoldPortraitOutlined />,
    color: "blue",
  },
  CODE_EDITOR: {
    label: "ai:code_editor",
    icon: <CodeOutlined />,
    color: "yellow",
  },
  LINK: {
    label: "ai:video_explorer",
    icon: <VideoOutlined />,
    color: "teal",
  },
  VIDEO: {
    label: "ai:video_explorer",
    icon: <VideoOutlined />,
    color: "teal",
  },
  WORKBOOK: {
    label: "common:workbook",
    icon: <WorkbookOutlined />,
    color: "pink",
  },
};

// dialog constants
export const INITIAL_DIALOG_STATE = {
  action: null,
  params: {},
};

export const DIALOG_ACTIONS = {
  SHOW_CLOSE_DIALOG: "SHOW_CLOSE_DIALOG",
};

export const DIALOGS_INFO = {
  [DIALOG_ACTIONS.SHOW_CLOSE_DIALOG]: {
    title: ({ t, label }) =>
      t("ai:close_with_label", {
        label: label || t("common:untitled"),
      }),
    message: ({ t, label }) =>
      t("ai:changes_will_not_be_saved_warning_msg", {
        label: label || t("common:untitled"),
      }),
    buttonOneText: ({ t }) => t("classRoom:no_keep_editing"),
    buttonTwoText: ({ t }) => t("classRoom:yes_discard_changes"),
  },
};

export const MODALITY_DOC_EDITOR_CONFIG = {
  toolbar: {
    AI: {
      isEnabled: false,
    },
    comments: {
      isEnabled: false,
    },
  },
  floatingToolbar: {
    AI: {
      isEnabled: false,
    },
    comments: {
      isEnabled: false,
    },
  },
};
